import { PayloadAction } from '@reduxjs/toolkit';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { STATE__ui } from '../STATE__ui';

export const LOCAL__ui_g_general__sidebar_field_hovered_set = (payload: FIELD__base = FIELD__base.CREATE_STUB()): PayloadAction<FIELD__base> => ({
  type: ENUM__redux_action.UI_GENERATION_GENERAL__SIDEBAR_FIELD_HOVERED_SET,
  payload,
});

export function INIT_LOCAL__ui_g_general__sidebar_field_hovered_set(state: STATE__ui, action: PayloadAction<FIELD__base>) {
  state.g_general__sidebar_field_hovered = action.payload.clone();
}
